import React from 'react';
export function ScoreBadge({
  score,
  size = 'md'
}: {
  score: number;
  size?: 'md' | 'lg';
}) {
  const formatted = score.toLocaleString('nl-NL', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
  if (size === 'lg') {
    return <div className="flex flex-col items-center justify-center rounded-2xl bg-fern px-5 py-3 text-white" data-id="element-267" data-mp="3gbacc7hzimj7">
        <span className="font-serif text-4xl font-semibold leading-none" data-id="element-268" data-mp="3l4v77qoa70e6">{formatted}</span>
        <span className="mt-1 text-[11px] font-medium text-white/80" data-id="element-269" data-mp="3q2etndv4ujh7">SlotGids Score</span>
      </div>;
  }
  return <span className="inline-flex h-9 w-12 items-center justify-center rounded-lg bg-fern font-serif text-base font-semibold text-white" aria-label={`SlotGids Score ${formatted} van 10`} data-id="element-270" data-mp="3v3kn5dwmaars">
      {formatted}
    </span>;
}